// src/context/AlertContext.js
import React, { createContext, useContext, useState } from 'react';
import Failure from '../components/Failure';
import Success from '../components/Success';


const AlertContext = createContext();

export const useAlerts = () => useContext(AlertContext);

export const AlertProvider = ({ children }) => {
    const [successAlert, setSuccessAlert] = useState({
        show: false,
        message: '',
    });

    const [errorAlert, setErrorAlert] = useState({
        show: false,
        message: '',
    });

    const showSuccess = (message) => {
        setSuccessAlert({
            show: true,
            message,
        });

        // Auto-hide after 3 seconds (optional)
        setTimeout(() => {
            setSuccessAlert({
                show: false,
                message: '',
            });
        }, 3000);
    };

    const hideSuccess = () => {
        setSuccessAlert({
            show: false,
            message: '',
        });
    };

    const showError = (message) => {
        setErrorAlert({
            show: true,
            message,
        });

        // Auto-hide after 5 seconds (optional)
        setTimeout(() => {
            setErrorAlert({
                show: false,
                message: '',
            });
        }, 5000);
    };

    const hideError = () => {
        setErrorAlert({
            show: false,
            message: '',
        });
    };

    return (
        <AlertContext.Provider
            value={{
                showSuccess,
                hideSuccess,
                showError,
                hideError,
            }}
        >
            {children}

            {/* Render the alert components */}
            <Success
                show={successAlert.show}
                close={hideSuccess}
                message={successAlert.message}
            />

            {/* Assuming you have an Error component */}
            <Failure
                show={errorAlert.show}
                close={hideError}
                message={errorAlert.message}
            />
        </AlertContext.Provider>
    );
};